import axios from '@/plugins/axios'

function store(data) {
  return axios.post('/service-tasks-repositories', data)
    .then(response => response.data)
}
function update(data, id) {
  return axios.patch(`/service-tasks-repositories/${id}`, data)
    .then(response => response.data)
}

export default {
  save(data, id) {
    return id ? update(data, id) : store(data)
  },
  fetch(params) {
    return axios.get('/service-tasks-repositories', { params: params })
      .then(response => response.data)
  },
  getWinteringTasksForYacht(yachtId) {
    return axios.get(`/service-tasks-repositories/wintering/${yachtId}`)
      .then(response => response.data)
  },
  destroy(id) {
    return axios.delete(`/service-tasks-repositories/${id}`)
  }
}
